import React, { useEffect, useState } from 'react';
import Hdfc from '../assets/images/hdfc.png'
import After from '../assets/images/Vectorafter.png'
import Afteractive from '../assets/images/VectorActive.png'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../assets/images/Logo.png'
import Usa from '../assets/images/Usa.png'
import Cad from '../assets/images/Cnd.png'
import Nocheck from '../assets/images/nocheck.png'
import Yescheck from '../assets/images/yescheck.png'
import Aedimg from '../assets/images/Aed.png'
import AuthService from '../services/auth.service';
import { showToast } from '../app/slice/toastsSlice';
import { AppDispatch } from '../app/store';
import { useDispatch } from 'react-redux';

function Addbank() {
    const dispatch = useDispatch<AppDispatch>();
    const [showmethod, setMethod] = useState(false);
    const handleClosemethod = () => setMethod(false);
    const handleShowmethod = () => setMethod(true);
    const [loading, setLoading] = useState(false);
    const [ifscLoading, setIfscLoading] = useState(false);
    const [errors, setErrors] = useState<any>({});
    const [message, setMessage] = useState("");
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        account_holder: "",
        account_number: "",
        c_account_number: "",
        ifsc_code: "",
        bank_name: "",
        is_ifsc_valid: false,
        bank_type: "Bank"
    });

    // State to track the index of the clicked <li>
    const [selectedCurrency, setSelectedCurrency] = useState<number | null>(null);

    // Handle the click event on the form-check div
    const handleClickCurrency = (index: number) => {
        setSelectedCurrency(index); // Set the clicked index
    };

    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

    // Handle the click event on the form-check div
    const handleClick = (index: number) => {
        setSelectedIndex(index); // Set the clicked index
    };

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;

        if ((name === 'account_number' || name === 'c_account_number') && isNaN(e.target.value)) {
            return false
        }

        if (e.target.name === 'ifsc_code' && (e.target.value).length === 11) {
            setErrors({ [`ifsc_code`]: "" });
            setIfscLoading(true);
            setFormData({
                ...formData,
                [`bank_name`]: '',
            });
            AuthService.checkIFSC(e.target.value).then(
                (response) => {
                    if (!response) {
                        setErrors({ [`ifsc_code`]: "Invalid IFSC Code" });
                    }
                    setFormData(prev => ({
                        ...prev,
                        [`bank_name`]: response.BANK,
                        [name]: response.IFSC,
                        [`is_ifsc_valid`]: true,
                    }));
                }
            ).catch((error: any) => {
                setErrors({ [`ifsc_code`]: "Invalid IFSC Code" });
                setFormData(prev => ({
                    ...prev,
                    [name]: value,
                    [`is_ifsc_valid`]: false,
                }));

            }).finally(() => {
                setIfscLoading(false);
            });
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value,
            }));
        }

    }

    const validateForm = () => {
        let isValid = true;
        const newErrors: any = {};

        if (!formData.account_holder) {
            newErrors.name = "Account holder name is required";
            isValid = false;
        }

        if (!formData.account_number) {
            newErrors.account_number = "Account no. is required";
            isValid = false;
        }

        if (formData.c_account_number !== formData.account_number) {
            newErrors.c_account_number = "Account no. does not match";
            isValid = false;
        }

        if (!formData.c_account_number) {
            newErrors.c_account_number = "Confirm Account no. is required";
            isValid = false;
        }

        if (!formData.is_ifsc_valid) {
            newErrors.ifsc_code = "Invalid IFSC code";
            isValid = false;
        }

        if (!formData.ifsc_code) {
            newErrors.ifsc_code = "IFSC code is required";
            isValid = false;
        }

        if (!formData.bank_name) {
            newErrors.bank_name = "Bank Name is required";
            isValid = false;
        }

        if (!isValid) {
            setLoading(false);
        }
        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        setMessage('');
        setLoading(true);

        if (validateForm()) {

            AuthService.addBank(formData).then(
                (response) => {
                    if (response.status === 200) {
                        setMessage(response.message);
                        setFormData({
                            ...formData,
                            [`account_holder`]: '',
                            [`account_number`]: '',
                            [`c_account_number`]: '',
                            [`ifsc_code`]: '',
                            [`bank_name`]: '',
                            [`is_ifsc_valid`]: false,
                        });
                        let toast = {
                            type: 'success',
                            title: 'Success',
                            message: response.message
                        }
                        dispatch(showToast(toast));
                    } else {
                        setMessage(response?.message);
                    }

                }
            ).catch((error: any) => {
                const message = error?.response?.data?.error_description;
                setMessage(message);
                if (error?.response?.data?.status === 401) {
                    localStorage.removeItem("w_token");
                    navigate('/login');
                } else {
                    let toast = {
                        type: 'error',
                        title: 'Error',
                        message: message
                    }
                    dispatch(showToast(toast));
                }
            }).finally(() => {
                setLoading(false);
            });
        }

    }

    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-12 bankDetal mt-2" style={{ background: 'none' }}>
                        <form onSubmit={handleSubmit}>
                            <label>Account Holder Name <sup style={{ color: '#F75653' }}>*</sup></label>
                            <div className="inputBank">
                                <input
                                    className="trxId"
                                    type="text"
                                    name="account_holder"
                                    placeholder="Account holder name"
                                    autoComplete="off"
                                    value={formData.account_holder}
                                    onChange={(e) => handleInputChange(e)} />
                            </div>
                            {errors.name && <div className="text-danger pb-2 "><small>{errors.name}</small></div>}

                            <label>Account Number  <sup style={{ color: '#F75653' }}>*</sup></label>
                            <div className="inputBank">
                                <input
                                    className="trxId"
                                    type="tel"
                                    name="account_number"
                                    aria-describedby="account_number"
                                    placeholder="Account Number"
                                    autoComplete="off"
                                    maxLength={16}
                                    value={formData.account_number}
                                    onChange={(e) => handleInputChange(e)}
                                    style={{ letterSpacing: '1px' }} />
                            </div>
                            {errors.account_number && <div className="text-danger pb-2 "><small>{errors.account_number}</small></div>}

                            <label>Confirm Account Number  <sup style={{ color: '#F75653' }}>*</sup></label>
                            <div className="inputBank">
                                <input
                                    className="trxId"
                                    type="tel"
                                    name="c_account_number"
                                    placeholder="Confirm Account Number"
                                    autoComplete="off"
                                    maxLength={16}
                                    value={formData.c_account_number}
                                    onChange={(e) => handleInputChange(e)}
                                    style={{ letterSpacing: '1px' }} />
                            </div>
                            {errors.c_account_number && <div className="text-danger pb-2 "><small>{errors.c_account_number}</small></div>}

                            <label>IFSC Code <sup style={{ color: '#F75653' }}>*</sup></label>
                            <div className="inputBank">
                                <input
                                    className="trxId"
                                    type="text"
                                    name="ifsc_code"
                                    placeholder="IFSC Code"
                                    autoComplete="off"
                                    maxLength={11}
                                    pattern="[A-Z]{4}[0][A-Z0-9]{6}$"
                                    value={formData.ifsc_code}
                                    onChange={(e) => handleInputChange(e)}
                                    style={{ letterSpacing: '1px' }} />
                            </div>
                            {errors.ifsc && <div className="text-danger pb-2 "><small>{errors.ifsc}</small></div>}

                            <label>Bank Name <sup style={{ color: '#F75653' }}>*</sup></label>
                            <div className="inputBank">
                                <input
                                    className="trxId"
                                    type="text"
                                    name="bank_name"
                                    placeholder="Bank Name"
                                    onChange={(e) => handleInputChange(e)}
                                    value={formData.bank_name}
                                    style={{ letterSpacing: '1px' }} />
                            </div>


                            {message && (
                                <div className='d-block text-danger text-center' role="alert">
                                    {message}
                                </div>
                            )}
                            <button type="submit" className="addMony mt-3" disabled={loading} >
                                {loading ?
                                    <>
                                        <span className="spinner-border spinner-border-sm me-1" role="status"></span>Please wait...
                                    </>
                                    :
                                    <>Add Bank</>
                                }
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Addbank;